import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import colors from "../../Constants/colors";
import { useTranslation } from "react-i18next";
import { ComoButton } from "../Common/ComoButton";

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("myQuestionLists");

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ color: colors.primary_dark, fontWeight: 600 }}
      >
        {t("myQuestionLists.dialogs.deleteDialogTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: colors.gray700 }}
        >
          {t("myQuestionLists.dialogs.deleteDialogMessage")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <ComoButton onClick={onClose} disabled={loading} secondary>
          {t("myQuestionLists.dialogs.deleteCancel")}
        </ComoButton>
        <ComoButton onClick={handleConfirm} disabled={loading}>
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            t("myQuestionLists.dialogs.deleteConfirm")
          )}
        </ComoButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
